import React, { Component } from 'react';
import { Container, Card } from 'semantic-ui-react';

import Description from './Description';

export default class AboutMe extends Component {
  render () {
    return (
      <Container id="aboutMe" fluid>
        <Card fluid>
          <Card.Content header="A short resume of who I am..." />
          <Card.Content description={<Description />} />    
        </Card>
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/AboutMe.js